<template>
  <div class="container">
    <div class="info-top">
      <div @click.stop="toHomePage(info.MemberId)">
        <van-image
          fit="cover"
          :src="info.Photo"
          round
          error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
        />
        <span>{{ info.Headline }}</span>
      </div>
      <div
        class="follow"
        :class="info.IsFollow ? 'active' : ''"
        @click.stop="followChange(info.MemberId)"
      >
        <span class="iconfont icon-add" v-if="!info.IsFollow"></span
        >{{ info.IsFollow ? "已关注" : "关注" }}
      </div>
    </div>

    <div
      class="swiper-box"
      v-if="info.Details != null && info.Details.length > 0"
    >
      <van-swipe
        style="width: 100%; height: 100%"
        indicator-dots="true"
        indicator-color="rgba(0, 0, 0, .3)"
        indicator-active-color="rgba(0, 0, 0, 1)"
        :initial-swipe="currentSwipe"
      >
        <van-swipe-item v-for="(item, index) in info.Details" :key="index">
          <van-image
            fit="cover"
            :src="item.Thumbnail"
            class="banImage"
            @click="clickPreview(info.Details, index)"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="info-box">
      <div class="text-box" v-html="info.Content"></div>
      <div class="other">
        <div class="label_wrap">
          <div class="circle" v-if="info.Circle">
            <div class="iconfont icon-quanzi"></div>
            广州灯光节生活圈
          </div>
          <div class="topic">
            <div v-for="(item, index) in info.TopicList" :key="index">
              <div
                :style="
                  index == 1
                    ? 'color:#7896d3;'
                    : index == 2
                    ? 'color:#d4a345;'
                    : ''
                "
                @click="toTopicDetail(item.TopicId)"
              >
                #{{ item.TopicName }}#
              </div>
            </div>
          </div>
        </div>
        <div
          class="product"
          v-if="info.PostGoodModel"
          @click="toProductDetail(info.PostGoodModel.GoodsID)"
        >
          <img class="proImg" :src="info.PostGoodModel.Thumbnail" />
          <div class="overFlowOne">同款产品</div>
        </div>
      </div>
      <div class="dateBox">
        <div class="date">{{ info.Times }}</div>
        <div>浏览数：{{ info.Views }}</div>
      </div>
      <div
        class="watch-box"
        v-if="info.HeadPhotoList != null && info.HeadPhotoList.length > 0"
      >
        <div class="avater_wrap">
          <div v-for="(item, index) in info.HeadPhotoList" :key="index">
            <img
              v-if="index < 12"
              :src="item"
              :style="{
                left: `-${index * 15}px`,
                zIndex: `${20 - index}`,
              }"
            />
          </div>
        </div>
        <div
          v-if="info.LikeCount"
          class="num"
          :style="{
            left: `${
              info.HeadPhotoList.length > 12
                ? 12 * 15 + 20
                : info.HeadPhotoList.length * 15 + 20
            }px`,
          }"
        >
          <div
            class="iconfont icon-ellipsis"
            style="font-size: 25px"
            v-if="info.LikeCount > 12"
          ></div>
          <div style="display: flex; margin-left: 14px">
            <div class="overFlowOne">{{ info.LastLikeUser }}</div>
            <div>等{{ info.LikeCount }}人赞过</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 评论列表 -->
    <div class="comment-box">
      <div class="title">
        <span>评论</span><span v-if="info.Comment">({{ info.Comment }})</span>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getCommentHandle"
      >
        <div v-for="(item, index) in commentList" :key="index">
          <div class="c_item">
            <img :src="item.Photo" class="avatarImg" />
            <div class="ci_right">
              <div class="cir_top">
                <div>{{ item.MemberName }}</div>
                <div
                  class="like"
                  @click.stop="onLikeChange(item.RecordId, index)"
                >
                  <van-icon
                    :color="item.IsLike ? '#d62f2f' : '#999'"
                    :name="item.IsLike ? 'like' : 'like-o'"
                    size="18px"
                  />
                  <div v-if="item.LikeCount">{{ item.LikeCount }}</div>
                </div>
              </div>
              <div class="content" @click.stop="toReply(item.RecordId, index)">
                {{ item.Content }}
              </div>
              <div class="time">
                {{ item.CreateTimeDesc }}
                <div
                  @click.stop="onReply(item.RecordId, index)"
                  v-if="item.CommentCount"
                >
                  {{ item.CommentCount }}回复
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>

      <div class="noComment" v-if="commentList.length == 0">
        <div class="kongIcon"><span class="iconfont icon-kong"></span></div>
        <div>暂无评论，留下你的看法吧~</div>
      </div>
    </div>

    <!-- 回复弹窗内容 -->
    <van-popup
      v-model="replyModal"
      closeable
      :overlay="true"
      class="comment_container"
      position="bottom"
    >
      <div class="comment_box">
        <div class="comment_top">{{ replyList.length }}条评论</div>
        <ul class="comment_ul">
          <li
            class="comment_li"
            v-for="(item, index) in replyList"
            :key="index"
          >
            <div class="comment_author_left">
              <img :src="item.Photo" />
            </div>
            <div class="comment_author_right">
              <div class="comment_author_top">
                <div class="comment_author_name">{{ item.MemberName }}</div>
                <div
                  class="icon-shoucang1_box"
                  @click.stop="onReplyChange(item.RecordId, index)"
                >
                  <van-icon
                    :color="item.IsLike ? '#d62f2f' : '#999'"
                    :name="item.IsLike ? 'like' : 'like-o'"
                    size="18px"
                  />
                  <div class="shoucang1_num" v-if="item.LikeCount">
                    {{ item.LikeCount }}
                  </div>
                </div>
              </div>
              <div class="comment_author_text">
                {{ item.Content }}
              </div>
              <div class="comment_author_time">{{ item.CreateTimeDesc }}</div>
            </div>
            <div class="clear"></div>
          </li>
        </ul>
      </div>
    </van-popup>

    <!--留言输入-->
    <van-overlay v-show="inputModal" @click="inputModal = false">
      <div class="selfComment-box" @click.stop="">
        <div class="scb_close" @click.stop="commentChange">
          <div class="iconfont icon-close"></div>
          <div class="scb_publish" @click.stop="commentConfirm">发表</div>
        </div>
        <textarea
          rows="3"
          :placeholder="placeholder"
          v-model="commentText"
          confirm-type="send"
          @keyup.enter="commentConfirm"
        ></textarea>
      </div>
    </van-overlay>

    <!-- 底部操作栏 -->
    <div class="btm_action_bar">
      <div class="inputSeize" @click.stop="showInput">说说你的看法吧~</div>
      <div class="operate">
        <!-- <div @click.stop="officialAccount">
          <span class="iconfont icon-weixin"></span>
        </div> -->
        <div @click.stop="shareHandle">
          <span class="iconfont icon-share1"></span>
        </div>
        <div @click.stop="likeChange(info.PostId)">
          <span
            class="iconfont"
            :class="info.IsLike ? 'icon-favorites-fill' : 'icon-favorites'"
            :style="info.IsLike ? 'color:#D62F2F;' : ''"
          ></span>
        </div>
      </div>
    </div>
    <!--分享-->
    <div class="shareLayer" v-show="showLayer" @click="showLayer = false">
      <img src="../../../static/images/index/layer.png" />
    </div>
    <!--遮罩层-->
    <van-overlay v-show="showLayer" @click="showLayer = false"></van-overlay>
  </div>
</template>
<script>
import { getShareData } from "@/utils/share";
import {
  postPicDetail,
  createPostLike,
  cancelPostLike,
  followMember,
  unFollowMember,
  postComment,
  postCommentLike,
  cancelCommentLike,
  createPostComment,
} from "@/api/index";
import {
  Icon,
  Swipe,
  SwipeItem,
  Tabbar,
  TabbarItem,
  Row,
  Col,
  Popup,
  List,
  Toast,
  Overlay,
  Image,
  ImagePreview,
} from "vant";
export default {
  name: "trendDetails",
  components: {
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
    "van-row": Row,
    "van-col": Col,
    "van-icon": Icon,
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-popup": Popup,
    "van-list": List,
    "van-overlay": Overlay,
    "van-image": Image,
    Toast,
    ImagePreview,
  },
  data() {
    return {
      currentSwipe: 0, //当前轮播的图片

      showLayer: false,
      info: "",
      infoLength: "", //头像列表长度
      showLiker: "", //显示点赞人名字
      commentText: "", //评论输入内容
      placeholder: "点击发表评论",
      inputModal: false, //输入框
      replyModal: false, //回复弹窗

      loading: false,
      finished: false,
      error: false,
      pageIndex: 1,
      total: 0,
      commentList: [], //评论列表

      rloading: false,
      rfinished: false,
      rerror: false,

      replyPageIndex: 1,
      replyTotal: 0,
      replyList: [], //回复列表

      replyId: null, //回复id-(用于评论or评论的回复)
      replyIndex: 0, //点击（回复）or（评论）时的下标值
    };
  },
  methods: {
    //跳转个人主页
    toHomePage(id) {
      this.$router.push({ path: "/homePage", query: { mid: id } });
    },

    //跳转公众号
    officialAccount() {
      window.location.href =
        "https://mp.weixin.qq.com/s/n7PtZNJDhiWnxQq04I8sSg";
    },

    //跳转话题详情
    toTopicDetail(hid) {
      this.$router.push({ path: "/hotTopicDetails", query: { hid: hid } });
    },

    //跳转产品详情
    toProductDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { id: id },
      });
    },

    //分享好友
    shareHandle() {
      this.showLayer = true;
    },

    //预览轮播图
    clickPreview(list, index) {
      var newlist = [];
      list.map((item, index) => {
        newlist.push(item.Thumbnail);
      });
      ImagePreview(newlist,index);
    },

    //获取动态详情
    getDetail() {
      var data = {
        PostId: this.$route.query.tid,
      };
      postPicDetail(data).then((res) => {
        this.info = res.Data;
        this.infoLength = res.Data.HeadPhotoList.length;
        this.showLiker = res.Data.LastLikeUser;
        getShareData(
          window.location.href,
          res.Data.Headline + "分享了一条动态，快来看看呀！",
          this.Common.ToText(res.Data.Content).substr(0, 50)
            ? this.Common.ToText(res.Data.Content).substr(0, 50)
            : "",
          "https://files.alighting.com/uploads/202103/20210316104037472802.jpg"
        );
      });
    },

    //点赞操作
    likeChange(id) {
      var newInfo = this.info;
      if (newInfo.IsLike) {
        cancelPostLike({ PostId: id }).then((res) => {
          newInfo.IsLike = false;
          newInfo.LikeCount--;
          this.getDetail();
        });
      } else {
        createPostLike({ PostId: id }).then((res) => {
          newInfo.IsLike = true;
          newInfo.LikeCount++;
          this.getDetail();
        });
      }
      this.info = newInfo;
    },

    //头条号操作
    followChange(id) {
      var newInfo = this.info;
      if (newInfo.IsFollow) {
        unFollowMember({ MemberId: id }).then((res) => {
          Toast("取消关注");
          newInfo.IsFollow = false;
        });
      } else {
        followMember({ MemberId: id }).then((res) => {
          Toast("关注成功");
          newInfo.IsFollow = true;
        });
      }
      this.info = newInfo;
    },

    //获取评论列表
    getCommentHandle() {
      var that = this;
      var data = {
        PostId: this.$route.query.tid,
        Page: {
          PageSize: 20,
          PageIndex: this.pageIndex,
        },
        CommentRecordId: 0,
      };
      postComment(data).then((res) => {
        if (that.pageIndex == 1) {
          that.commentList = [...res.Data.List];
        } else {
          that.commentList = [...that.commentList, ...res.Data.List];
        }
        that.total = res.Data.Total;
        that.pageIndex += 1;
        // 加载状态结束
        that.loading = false;
        // 数据全部加载完成
        if (that.commentList.length >= that.total) {
          that.finished = true;
        }
      });
    },

    //评论点赞
    onLikeChange(rid, index) {
      var list = this.commentList;
      if (list[index].IsLike) {
        cancelCommentLike({
          RecordId: rid,
          PostId: this.$route.query.tid,
        }).then((res) => {
          list[index].IsLike = false;
          list[index].LikeCount--;
        });
      } else {
        postCommentLike({ RecordId: rid, PostId: this.$route.query.tid }).then(
          (res) => {
            list[index].IsLike = true;
            list[index].LikeCount++;
          }
        );
      }
      this.commentList = list;
    },

    //获取回复列表
    getReplyHandle() {
      var that = this;
      var data = {
        PostId: that.$route.query.tid,
        Page: {
          PageSize: 10,
          PageIndex: that.replyPageIndex,
        },
        CommentRecordId: that.replyId,
      };
      postComment(data).then((res) => {
        if (that.replyPageIndex == 1) {
          that.replyList = [...res.Data.List];
        } else {
          that.replyList = [...that.replyList, ...res.Data.List];
        }
        that.replyTotal = res.Data.Total;
        if (that.replyList.length >= that.replyTotal) {
          console.log("数据加载完毕");
        } else {
          if (that.replyList.length > 0) {
            that.replyPageIndex = that.replyPageIndex += 1;
            that.getReplyHandle();
          } else {
            console.log("底部了");
          }
        }
      });
    },

    //回复评论点赞
    onReplyChange(rid, index) {
      var list = this.replyList;
      if (list[index].IsLike) {
        cancelCommentLike({
          RecordId: rid,
          PostId: this.$route.query.tid,
        }).then((res) => {
          list[index].IsLike = false;
          list[index].LikeCount--;
        });
      } else {
        postCommentLike({ RecordId: rid, PostId: this.$route.query.tid }).then(
          (res) => {
            list[index].IsLike = true;
            list[index].LikeCount++;
          }
        );
      }
      this.replyList = list;
    },

    //点击评论按钮
    showInput() {
      this.commentText = "";
      this.placeholder = "点击发表评论";
      this.replyId = 0;
      this.inputModal = !this.inputModal;
    },

    //点击回复弹窗
    onReply(rid, index) {
      this.replyModal = true;
      this.replyId = rid;
      this.replyIndex = index;
      this.replyPageIndex = 1;
      this.replyList = [];
      this.getReplyHandle();
    },

    //点击评论进行回复
    toReply(rid, index) {
      this.replyId = rid;
      this.replyIndex = index;
      this.commentText = "";
      this.inputModal = !this.inputModal;
      this.placeholder = "@" + this.commentList[index].MemberName;
    },

    //点击发表评论
    commentConfirm() {
      var that = this;
      var data = {
        Content: that.commentText,
        PostId: that.$route.query.tid,
        CommentRecordId: that.replyId ? that.replyId : 0,
      };
      createPostComment(data).then((res) => {
        setTimeout(() => {
          Toast("发表成功");
          this.commentText = "";
          this.info.Comment = this.info.Comment + 1;
          setTimeout(() => {
            that.commentChange();
            if (that.replyId) {
              that.replyPageIndex = 1;
              that.replyList = [];
              that.commentList[that.replyIndex].CommentCount =
                that.commentList[that.replyIndex].CommentCount + 1;
              that.getReplyHandle();
            } else {
              that.pageIndex = 1;
              that.commentList = [];
              that.getCommentHandle();
            }
          }, 1000);
        }, 0);
      });
    },

    //关闭评论弹窗
    commentChange() {
      this.inputModal = false;
    },
  },
  mounted() {
    this.getDetail();
    this.currentSwipe = this.$route.query.imgidx;
  },
};
</script>
<style scoped src="../../../static/css/common.css"></style>
<style scoped src="../../../static/css/trendDetails.css"></style>
